<template>
  <footer class="templates-app-footer text-light w-100">
    <div
      class="container-fluid d-flex flex-column flex-md-row align-items-center"
    >
      <div class="order-1 order-md-0">
        <div class="d-flex flex-column justify-content-start">
          <div :style="logoStyle" class="logo mx-auto mx-md-0" />
          <div class="d-lg-flex justify-content-center">
            <div class="warning small pt-3">
              ©{{ year }} – {{ $setup.getPartner("title") }} | Todos os Direitos
              Reservados
            </div>
            <!-- <div class="small pt-3">
            <a class="pr-4" href="#">Termos de uso</a>
            <a href="#">Privacidade e cookies</a>
          </div> -->
          </div>
        </div>
      </div>
      <div class="order-0 order-md-1 ml-md-auto mb-4 mb-md-0">
        <!-- <div class="app-buttons pr-md-5">
          Baixe o nosso app
          <button class="btn btn-outline-secondary" @click="appStore">
            <div class="d-flex align-items-center justify-content-between">
              <i class="fa-brands fa-apple mr-2"></i>
              App Store
            </div>
          </button>
          <button class="btn btn-outline-secondary" @click="googlePlay">
            <div class="d-flex align-items-center justify-content-between">
              <i class="fa-brands fa-google-play mr-2"></i>
              Google Play
            </div>
          </button>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear();
    },
    logoStyle() {
      return {
        "background-image": `url(${this.$setup.partnerLogo})`
      };
    }
  },
  methods: {
    appStore() {
      window.location.href =
        "https://apps.apple.com/br/app/velora-%C3%A1rea-de-membros/id6451417807";
      target: "_blank";
    },
    googlePlay() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.velora.members&hl=pt_BR&gl=US";
      target: "_blank";
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-app-footer {
  padding: 8px 0;
  margin-bottom: 24px;
  background-color: transparent;

  a {
    font-weight: bold;
    text-decoration: none;
  }

  .warning {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  .logo {
    background-size: contain;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    width: 150px;
    height: 40px;
  }

  .app-buttons {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .btn-outline-secondary {
    padding: 0 60px;
    border-radius: 30px;
    border: 1px solid var(--Verso-Dark-Grey-1, #bebfc7);
    * {
      color: var(--Verso-Dark-Grey-1, #bebfc7);
    }
  }
}
</style>
